<template>
  <div>
    <v-simple-table class="simple-table">
      <template v-slot:default>
        <tbody>

          <tr
            v-for="(c, index) in item.checklist"
            :key="c.id"
          >
            <td>
                <v-tooltip right nudge-left="300" :disabled="$store.getters.device !== 'desktop'">
                  <template v-slot:activator="{ on }">
                    <v-layout v-on="on" justify-left>
                      <v-checkbox
                        :disabled="read_only"
                        :input-value="c.value"
                        @change="setValue(c.id, index, $event)"
                        :label="c.checklist.name"
                      >
                      </v-checkbox>
                    </v-layout>
                </template>
                <span v-if="c.modified_by">{{ c.modified_by && c.modified_by.name }} {{ c.date_modified }}</span>
                <span v-else>Не отмечено</span>
              </v-tooltip>

              <v-textarea
                outlined
                class="mb-1"
                @input="setTextValue(c.id, index, $event)"
                hide-details rows="3"
                label="Комментарий"
                :disabled="read_only"
                v-if="c.value && c.checklist.text"
                v-model="item.checklist[index].text">
              </v-textarea>

              <MediaList
                v-if="c.value && c.checklist.files"
                :id="c.id"
                capture="user"
                accept="image/*"
                :url="mediaUrl"
                view="edit"
                v-model="c.files"
                :params="{ rotate: true }"
                :disabled="read_only"
              ></MediaList>

            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { get, edit, PREFIX } from '@/api'
import RefMixin from '@/views/Ref.vue'
import MediaList from '@/components/MediaList'
export default {
  mixins: [RefMixin],
  components: {
    MediaList
  },
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          checklist: []
        }
      }
    }
  },
  computed: {
    read_only () {
      return !this.item.is_participant
    },
  },
  data: function () {
    return {
      url: 'techservice/',

      // medialist
      mediaUrl: 'checklistitem/',
    }
  },
  methods: {
    setValue (id, index, e) {
      this.item.checklist[index].value = e
      this.saveItem(id, index, 'value')
    },
    setTextValue (id, index, e) {
      this.item.checklist[index].text = e
      this.saveItem(id, index, 'text')
    },
    saveItem (id, index, kindOf) {
      edit(this.url, id, this.item.checklist[index], 'check/').then((response) => {
        if (kindOf === 'value') {
          this.$notify({ group: 'main', title: `Сохранить: ${response.data.checklist.name}`, text: 'Успешно!', type: 'success' })
        }
        this.item.checklist[index].date_modified = response.data.date_modified
        this.item.checklist[index].modified_by = response.data.modified_by
      }).catch((err) => {
        console.log('ERRR', err)
        this.$notify({ group: 'main', title: 'Сохранить', text: 'Ошибка! ' + err.response.status + ' ' + err.response.statusText, type: 'error' })
      })
    },

  }
}
</script>
<style scoped>
.simple-table td {
  background-color: #F5F5F5 !important;
}

</style>
